<template>
  <!-- eslint-disable max-len -->
  <button
    @click.stop="handleClick"
    :class="{ disabled: !enabled }"
    aria-label="Continue"
    class="static-intro-button"
  >
    <svg id="activityIntroBtn" x="0px" y="0px" width="69px" height="136px" viewBox="0 0 69 136">
      <g id="btnSemiCircle">
        <path
          fill="#F9E945"
          d="M8.4,42.4C4.9,50.5,3.2,59,3.2,67.9s1.7,17.3,5.2,25.4c3.3,7.8,8,14.7,14.1,20.8c6.1,6,13,10.7,20.9,14
          c8.1,3.4,16.7,5.1,25.6,5.1V2.5c-8.9,0-17.5,1.7-25.6,5.1c-7.9,3.3-14.8,8-20.9,14S11.7,34.6,8.4,42.4z"
        />
        <path
          fill="#010101"
          d="M58.8,5.1c1-0.1,2.4-0.3,4.3-0.4l0.8-0.1c0.6,0,1.4-0.2,2.4-0.4C67.5,4.1,68.4,4,69,4V0.4
          c-0.9,0-2,0.1-3.3,0.4c-0.8,0.2-1.5,0.3-2.1,0.3l-0.8,0.1c-1.8,0.1-3.3,0.3-4.6,0.5c0,0-0.7,0.1-2,0.2c-1.3,0.1-2.5,0.3-3.4,0.5
          c-0.8,0.2-1.8,0.6-3.1,1.2c-0.9,0.4-1.6,0.7-1.9,0.8l-1.1,0.4c-1.5,0.5-2.9,1-4,1.4l-2,0.8c-1.9,0.7-3.2,1.3-4,1.7
          c-1.2,0.6-2.8,1.6-4.7,3l-1.3,0.8c-2.3,1.5-3.9,2.7-4.8,3.4c-0.7,0.6-1.7,1.6-3,3l-1.6,1.7c-1.4,1.4-2.9,3-4.4,4.7
          c-0.9,1.2-2.1,2.7-3.4,4.7l-0.4,0.6c-1.4,2.1-2.6,3.9-3.4,5.5c-1,1.8-2,3.8-2.8,5.8c-0.9,2.1-1.5,3.7-1.9,5
          c-0.2,0.5-0.5,1.1-0.8,1.9c-0.6,1.4-1,2.5-1.2,3.1c-0.2,0.7-0.3,1.8-0.4,3.3c0,0.9-0.1,1.6-0.2,2.1l-0.4,2
          c-0.3,1.4-0.5,2.5-0.6,3.3c-0.1,1-0.1,2.4-0.1,4.4l0,1c0,0.8,0.1,2,0.3,3.4l0.2,1.9c0,0.7,0,1.3,0,2.1c0,1.3,0,2.4,0.1,3.3
          c0.1,0.7,0.4,1.8,0.9,3.3l0.5,1.9c0.2,0.8,0.6,1.9,1.1,3.4l1.1,3.2c0.6,1.9,1.1,3.1,1.2,3.5l0.6,1.4c0.9,2.1,1.6,3.7,2.1,4.6
          c0.5,0.9,1.3,2.1,2.4,3.4l2.6,3.8c1,1.6,1.8,2.8,2.3,3.4c0.9,1,1.9,2.2,3.3,3.4l1.2,1.2c0.2,0.2,0.8,0.8,1.6,1.8
          c1.2,1.4,2.1,2.3,2.9,3c1.1,0.9,2.8,2.1,5.3,3.8c2.4,1.6,4.2,2.7,5.6,3.4c0.8,0.4,2.1,1,4,1.7l2.1,0.8c1.8,0.8,3.4,1.4,5,1.9
          c0.8,0.3,2,0.6,3.6,0.9l1.7,0.4c1.3,0.3,3.1,0.6,5.3,1c1.9,0.3,3.6,0.5,5.3,0.6c2.5,0.2,4.3,0.2,5.4,0.2v-3.5
          c-1.7,0-3.4-0.1-5.1-0.2c-1.9-0.2-3.6-0.4-5.1-0.6c-1.7-0.3-3.4-0.6-5-0.9l-1.8-0.4c-1.6-0.4-2.6-0.6-3.2-0.8
          c-1-0.3-2.6-0.9-4.7-1.8l-2.2-0.9c-1.6-0.6-2.8-1.1-3.5-1.5c-1.2-0.6-2.9-1.7-5.3-3.3c-2.1-1.4-3.7-2.6-5-3.6
          c-0.4-0.3-1.2-1.2-2.4-2.5c-0.6-0.8-1.2-1.4-1.8-2l-1.3-1.3c-1.4-1.4-2.4-2.4-3-3.1c-0.6-0.8-1.3-1.8-2-3.1
          c-0.9-1.4-1.3-2.1-1.3-2.1c-0.3-0.4-0.8-1.1-1.5-2c-1-1.3-1.7-2.3-2.1-3c-0.4-0.8-1.1-2.2-1.9-4.3l-0.6-1.3C9.9,92,9.5,90.9,9,89.4
          l-1.2-3.4c-0.5-1.2-0.8-2.2-1-3l-0.6-2c-0.4-1.2-0.6-2.2-0.7-2.9c-0.1-0.4-0.1-1.3-0.1-2.6c0-0.9,0-1.7,0-2.5
          c0-0.5-0.1-1.2-0.2-2.1c-0.2-1.2-0.2-2.2-0.2-2.9l0-1.1c0-1.8,0-3.2,0.1-4c0-0.7,0.2-1.6,0.5-2.8l0.5-2.2c0.1-0.6,0.2-1.4,0.2-2.4
          c0.1-1.4,0.2-2.3,0.3-2.7c0.2-0.6,0.5-1.4,1-2.5c0.4-0.8,0.7-1.6,1-2.3c0.5-1.4,1.1-3,1.8-4.7c0.8-1.8,1.7-3.6,2.7-5.5
          c0.8-1.5,1.9-3.2,3.2-5.2l0.4-0.6c1.4-2,2.4-3.4,3.2-4.4c1.3-1.6,2.7-3.1,4.2-4.5l1.7-1.8c1.2-1.3,2.1-2.2,2.6-2.6
          c1-0.8,2.5-1.9,4.5-3.2l1.3-0.8c2.3-1.5,3.8-2.4,4.5-2.8c0.7-0.4,1.9-0.9,3.6-1.5l2.1-0.8c0.9-0.4,2.1-0.8,3.7-1.3L49,7.7
          c0.7-0.2,1.4-0.5,2.3-0.9c1.3-0.5,2.1-0.9,2.5-0.9c0.5-0.1,1.5-0.3,2.9-0.4C57.6,5.3,58.3,5.2,58.8,5.1z"
        />
      </g>
      <g>
        <path
          fill="#FFFFFF"
          d="M40.5,84.1l19-19L41.1,47.2v7.7l-25.4,0.4v20.1h25.4L40.5,84.1z"
          stroke="black"
          stroke-width="2"
        />
      </g>
    </svg>
  </button>
</template>

<script>
export default {
  props: {
    enabled: {
      type: Boolean,
      default: false
    },
    onClick: {
      type: Function,
      required: true
    }
  },
  methods: {
    handleClick() {
      if (this.enabled) {
        this.onClick();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  width: 69px;
  height: 136px;
  padding: 0;
  border: none;
  background-color: transparent;
  cursor: pointer;
  opacity: 1;
  transition: opacity 0.2s linear;

  &.disabled {
    opacity: 0.2;
    cursor: not-allowed;
  }
}
</style>
